export type BrandingTheme = {
  uuid: string;
  level?: string;
  name: string;
  primaryColor: string;
  secondaryColor: string;
  buttonFontColor: string;
  logoUrl: string;
};

export type PublicBrandingTheme = {
  uuid: string;
  name: string;
  logoUrl: string;
  treasuryPrimeLogoId: string;
  primaryColor: string;
  buttonFontColor: string;
};

export type ColorPalette = {
  primary: string;
  secondary: string;
  tertiary: string;
  success: string;
  error: string;
  white: string;
  black: string;
  border: string;
};

export type ValidColors =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'success'
  | 'error'
  | 'white'
  | 'black'
  | 'border';

export type ValidNotifications = 'positive' | 'negative' | 'outline';

export type SVButtonVariant =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'outlined'
  | 'error'
  | 'success'
  | 'text';

export type BrandingThemeMobileThemeOptions = 'Dark' | 'Light' | 'Custom';
export type BrandingThemeFonts =
  | 'Arial'
  | 'Lato'
  | 'Montserrat'
  | 'Myriad'
  | 'Open Sans'
  | 'PT Sans'
  | 'PT Serif'
  | 'Roboto';
export type BrandingThemeCustomBackgroundOptions =
  | 'Silver Metal'
  | 'Dark Metal';
export type IntroVideoOptions =
  | 'America'
  | 'Atlanta'
  | 'Chicago'
  | 'Florida'
  | 'Laguna'
  | 'Los Angeles'
  | 'Massachusetts'
  | 'Michigan'
  | 'Minnesota'
  | 'National'
  | 'New Jersey'
  | 'New York'
  | 'North East'
  | 'Ohio'
  | 'Oklahoma'
  | 'San Diego'
  | 'San Francisco'
  | 'South East';
export type SplashScreenOptions = '1 Advisor';

export interface BrandingThemeAddSubmission {
  name: string;
  isProgramDefault: boolean;
  primaryColor: string;
  secondaryColor: string;
  buttonFontColor: string;
  logoUrl: string;
  mobileUi: {
    style: BrandingThemeMobileThemeOptions;
    customNavigationBackground: BrandingThemeCustomBackgroundOptions;
    customHeroBackground: BrandingThemeCustomBackgroundOptions;
    customHomeScreenBackground: BrandingThemeCustomBackgroundOptions;
    primaryColor: string;
    secondaryColor: string;
    customBottomNavigationSelectedIconColor: string;
    titleColor: string;
    titleHeroSectionColor: string;
    titleAccentSectionColor: string;
    mobileLogoUrl: string;
    introVideo: IntroVideoOptions;
    splashScreen: SplashScreenOptions;
    font: BrandingThemeFonts;
  };
}

export interface BrandingThemeEditSubmission
  extends BrandingThemeAddSubmission {
  uuid: string;
}

export interface BrandingThemeItem extends BrandingThemeAddSubmission {
  uuid: string;
  level?: string;
  companyId: string | null;
  lastUpdatedAt: string;
  lastUpdatedBy: {
    firstName: string;
    lastName: string;
    fullName: string;
    uuid: string;
  };
}

export interface BrandingThemeConfirmModalData {
  title: string;
  description: string;
  brandingTheme: BrandingThemeItem;
  onSubmit: (brandingTheme: BrandingThemeItem) => void;
}

export interface BrandingThemeForm {
  uuid?: string;
  level?: string;
  companyId?: string;
  brandingThemeName: string;
  general: {
    primaryColor: string;
    secondaryColor: string;
    buttonFontColor: string;
    logo: string;
  };
  mobile: {
    theme: BrandingThemeMobileThemeOptions;
    navigationBackground: BrandingThemeCustomBackgroundOptions;
    heroBackground: BrandingThemeCustomBackgroundOptions;
    homeScreenBackground: BrandingThemeCustomBackgroundOptions;
    primaryColor: string;
    secondaryColor: string;
    bottomNavIconSelectedColor: string;
    titleDefaultColor: string;
    heroSectionColor: string;
    titleAccentSectionColor: string;
    logo: string;
    splashScreen: SplashScreenOptions;
    introVideo: IntroVideoOptions;
    font: BrandingThemeFonts;
  };
}

export const queryKeys = {
  list: ['branding-theme'] as const,
};
